// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Link } from "react-router-dom";
import { LogIn, UserPlus, Settings, LogOut, User } from "lucide-react";
import { useKeycloak } from "../../context/KeycloakProvider";
import toast from "react-hot-toast";

const Header = () => {
  const { authenticated, getUserInfo, login, logout, register } = useKeycloak();
  const userInfo = getUserInfo();
  const handleLogout = () => {
    logout();
    toast.success("Logged out successfully");
  };

  const handleLogin = () => {
    login();
  };

  const handleRegister = () => {
    register();
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/logo_b_stadtplatz.svg"
                alt="Stadtplatz.de"
                className="h-60 w-60"
              />
            </Link>
          </div>

          <nav className="hidden space-x-8">
            <Link
              to="/"
              className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
            >
              Home
            </Link>
          </nav>

          <div className="md:hidden">
            <button className="text-gray-700 hover:text-gray-900">
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>

          <div className="hidden md:flex items-center space-x-4">
            {authenticated && userInfo ? (
              <>
                <div className="flex items-center space-x-2 text-sm text-gray-700">
                  <User className="h-4 w-4" />
                  <span>
                    {userInfo?.firstName || userInfo?.username || "User"}
                  </span>
                </div>

                <Link
                  to="/admin/dashboard"
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-purple-600 hover:text-purple-800"
                >
                  <Settings className="h-4 w-4 mr-1" />
                  Dashboard
                </Link>

                <button
                  onClick={handleLogout}
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-red-600 hover:text-red-800"
                >
                  <LogOut className="h-4 w-4 mr-1" />
                  Logout
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={handleLogin}
                  className="flex items-center px-3 py-2 rounded-md text-sm font-medium text-blue-600 hover:text-blue-800"
                >
                  <LogIn className="h-4 w-4 mr-1" />
                  Login
                </button>
                <button
                  onClick={handleRegister}
                  className="flex items-center px-4 py-2 rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
                >
                  <UserPlus className="h-4 w-4 mr-1" />
                  Register
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
